export { default } from "./LoadingState";
